import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=10ff023c&scoped=true"
import script from "./referral.vue?vue&type=script&lang=js"
export * from "./referral.vue?vue&type=script&lang=js"
import style0 from "./referral.vue?vue&type=style&index=0&id=10ff023c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff023c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ff023c')) {
      api.createRecord('10ff023c', component.options)
    } else {
      api.reload('10ff023c', component.options)
    }
    module.hot.accept("./referral.vue?vue&type=template&id=10ff023c&scoped=true", function () {
      api.rerender('10ff023c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serviceCenter/referral.vue"
export default component.exports